import { render, staticRenderFns } from "./FollowUpItem.vue?vue&type=template&id=2a2a1c9a&scoped=true&lang=pug&"
import script from "./FollowUpItem.vue?vue&type=script&lang=js&"
export * from "./FollowUpItem.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpItem.vue?vue&type=style&index=0&id=2a2a1c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a1c9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon,VRow,VSpacer})
